import { notification } from 'antd';
import i18next from 'i18next';

export const handleError = (error: any) => {
  console.log('error in handleError:', error);
  if (error?.status === 401) {
    window.location.reload();
    return;
  }

  if (
    error?.status === 400 &&
    error?.data?.errorCode === 'FIELD_INTERSECTION'
  ) {
    notification.error({
      message: i18next?.t(
        'Field.Notification.IntersectionError',
        'Intersecting fields cannot be created',
      ),
      placement: 'bottomRight',
    });
    return;
  }

  if (error?.status === 403) {
    notification.error({
      message: i18next?.t(
        'Global.Notification.Error.NoPermission',
        'You do not have permissions',
      ),
      placement: 'bottomRight',
    });
  } else {
    notification.error({
      message: i18next?.t(
        'Global.Notification.Error.Unexpected',
        'Unexpected error happened',
      ),
      placement: 'bottomRight',
      description: error?.data?.error,
    });
  }
};
